// src/modules/portal/components/BreadcrumbNav.tsx
// Navegação breadcrumb para o portal

import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ items }) => {
  return (
    <nav className="flex items-center gap-2 text-sm text-gray-600 mb-6">
      <Link 
        to="/" 
        className="hover:text-blue-600 transition-colors flex items-center gap-1"
      >
        <Home size={16} />
        <span>Início</span>
      </Link>
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight size={16} className="text-gray-400" />
          
          {item.path ? (
            <Link 
              to={item.path}
              className="hover:text-blue-600 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-800 font-semibold">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
